<script setup>
const loadingIndicator = useLoadingIndicator()
const colorMode = useColorMode()

const icon = computed(() => {
  const apiUrl = useRouterStore().apiUrl
  return apiUrl ? `${apiUrl}/setup/icon` : '/assets/images/favicon.ico'
})

// AG Grid v36: seletor CSS mudou para html/body[data-ag-theme-mode]; não funciona mais no elemento da grid
const agThemeMode = computed(() => colorMode.value === 'dark' ? 'dark-blue' : 'light')

useSeoMeta({
  titleTemplate: 'Synapse EIS/RIS - Enterprise Imaging',
  ogImage: '/assets/images/logo-genesis.png'
})
useHead({
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' }
  ],
  link: [
    { rel: 'icon', href: icon }
  ],
  htmlAttrs: {
    'lang': 'pt-br',
    'data-ag-theme-mode': agThemeMode
  }
})

onMounted(() => {
  // Garantir que o loading indicator inicia "limpo"
  loadingIndicator?.clear()
})
</script>

<template>
  <UApp>
    <!-- Nuxt Loading Indicator nativo -->
    <NuxtLoadingIndicator
      :height="4"
      :duration="2000"
      :throttle="200"
      color="#3B82F6"
    />

    <!-- Teleport: modais usam portal no body; assim o z-index do loader vale em relação a eles -->
    <Teleport to="body">
      <div
        v-if="loadingIndicator?.isLoading?.value"
        class="loader-container"
      >
        <NativeSpinner
          color="#D0D0D0"
          size="15px"
        />
      </div>
    </Teleport>

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>

<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0); /* Fundo preto com 50% de opacidade */
  backdrop-filter: blur(0.15px); /* Embarcado */
  z-index: 9999; /* Garante que o loader esteja acima de outros elementos */
}
</style>
